import { Link } from "react-router-dom";
import { Type } from "@themes/pollinator/ui/Type";

export type Props = {
  organizations: { id: number; name: string | null; programId: number }[];
  firstName: string | null;
};

export function OrgAdminBanner({ organizations, firstName }: Props) {
  if (organizations.length === 0) {
    return null;
  }

  return (
    <Type variant="body2">
      <span className="font-bold">{firstName ?? "Organization Admin"}</span>, manage{" "}
      {organizations.map((org, index) => (
        <span key={org.id}>
          <Link
            to={`/program/${org.programId}/organization/${org.id}/admin/outreach`}
            className="underline hover:text-brand-600"
          >
            {org.name ?? "Unknown Organization"}
          </Link>
          {index < organizations.length - 1 && ", "}
        </span>
      ))}
    </Type>
  );
}

export default OrgAdminBanner;
